import { HTMLProps } from 'react';
import { useLocation } from 'react-router-dom';

import { BackLink } from '../../../../../components/navigation/BackLink';
import { cm } from '../../../../../libs/cm';

type LayoutLeadsSimpleProps = HTMLProps<HTMLDivElement> & { backUrl?: string };

export const LayoutLeadsSimple = ({
  className,
  backUrl,
  children,
  ...rest
}: LayoutLeadsSimpleProps) => {
  const classes = cm(
    'tw-flex tw-flex-col tw-bg-white md:tw-flex-row',
    className
  );

  return (
    <div className={classes} {...rest}>
      <div className="tw-flex-1">
        <div className="tw-bg-[#f4f4f4] md:tw-px-14 tw-py-[1.88rem] tw-flex tw-justify-center">
          <div className="tw-px-[1rem] tw-min-w-[730px]">
            <div>
              <BackLink url={backUrl} />
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
